import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-cefloreco-side-by-side.js';

const html = `
<div
  data-use-custom-width="true"
  data-custom-width="1204"
  class="container"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="layout-section" data-attribute="layout-section">
    <div class="media-content" data-attribute="media-content" data-order-media="1" style="--order-media: 1">
      <img
        data-attribute="media-image"
        src="https://cdn.skyfastimg.com/images/2026/10/27/image-6ae01f8b539f0cc34a2f5c5d.webp?w=1000&q=100"
        alt=""
      />
    </div>
    <div class="text-content" data-attribute="text-content" data-order-text="2" style="--order-text: 2">
      <p style="color: #ff7657">Intelligence with a purpose</p>
      <h2>Helpful by design. <br />Human at heart.</h2>
      <p>
        We explore AI as a quiet layer of assistance—helping people discover faster, create more freely and stay in
        control.
      </p>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#000',
  textColor: '#fff',
  topPadding: true,
  bottomPadding: true,
});
